/**=========================================================
 * Module: labels.js
 * Labels Controller
 =========================================================*/

App.controller('LabelsController',
    ['$rootScope', '$scope', '$state', '$translate', '$window', '$localStorage', '$timeout', 'toggleStateService', 'Restangular', 'DataService', '$http', '$filter', 'ngDialog', 'toaster',
        function ($rootScope, $scope, $state, $translate, $window, $localStorage, $timeout, toggle, R, D, $http, $filter, ngDialog, toaster) {
            "use strict";

            $scope.pop = function (type, title, text) {
                toaster.pop(type, title, text, 0, 'trustedHtml');
              };

            $scope.page = {
                title: 'labels.LABELS',
                subTitle: ''
            };

            $scope.languages = ['it_IT', 'en_GB', 'de_DE']

            $scope.dataMap = {}
            $scope.data = []
            $scope.show = {}
            $scope.paths = []
            $scope.newLabel = {}

            $scope.jsons = {}

            function process(key,value, path, lang) {
                if($scope.paths.indexOf(path)<0) {
                    $scope.paths.push(path)
                    $scope.paths.sort()
                    $scope.newLabel[path] = {}
                }
                var k = path ? path + '.' + key : key
                var o = { path: path, name: key }
                o[lang] = value
                $scope.dataMap[k] = Object.assign({}, $scope.dataMap[k], o)
            }

            function update(key,value, path, lang) {
                var k = (path ? path + '.' + key : key).split('.')
                var o = $scope.jsons[lang]
                var p = {}
                for(var i=0; i<k.length-1; i++){
                    if(i==k.length-2) p = o[k[i]]
                    o = o[k[i]]
                }
                o[key] = $scope.data.filter(function(d){ return d.path==path && d.name==key })[0][lang]
            }


            function traverse(o, func, path, lang) {
                for (var i in o) {
                    if(typeof(o[i])!="object"){
                        func.apply(this,[i,o[i], path, lang]);  
                    }
                    if (o[i] !== null && typeof(o[i])=="object") {
                        //going one step down in the object tree!!
                        traverse(o[i],func, path ? path + '.' + i : i, lang);
                    }
                }
            }

            $scope.showFilter = false
            $scope.filterMissing = function(){
                if($scope.showFilter && $scope.filter!='missing'){$scope.showFilter=false}
                $scope.showFilter = !$scope.showFilter
                $scope.filter = $scope.showFilter ? 'missing' : ''
                for(var i in $scope.data){
                    $scope.data[i].filtered = false
                    for(var l in $scope.languages){
                        if(!$scope.data[i][$scope.languages[l]]){
                            $scope.data[i].filtered = true
                        }
                    }
                }
            }

            $scope.filterDup = function(){
                if($scope.showFilter && $scope.filter!='dup'){$scope.showFilter=false}
                $scope.showFilter = !$scope.showFilter
                $scope.filter = $scope.showFilter ? 'dup' : ''
                for(var i in $scope.data){
                    $scope.data[i].filtered = false
                    for(var l in $scope.languages){
                        for(var k in $scope.languages){
                            if($scope.data[i][$scope.languages[l]]==$scope.data[i][$scope.languages[k]] && k!=l && $scope.data[i][$scope.languages[l]]){
                                $scope.data[i].filtered = true
                            }
                        }
                    }
                }
            }

            $scope.filterAll = function(){
                if($scope.showFilter && $scope.filter!='all'){$scope.showFilter=false}
                $scope.showFilter = !$scope.showFilter
                $scope.filter = $scope.showFilter ? 'all' : ''
                for(var i in $scope.data){
                    $scope.data[i].filtered = true
                }
            }

            $scope.filterString = function(){
                $scope.showFilter = true
                $scope.filter = $scope.showFilter ? 'string' : ''
                for(var i in $scope.data){
                    $scope.data[i].filtered = $scope.stringToFilter.trim() ? $scope.data[i].name.toLowerCase().indexOf($scope.stringToFilter.toLowerCase())>=0 : false
                    for(var l in $scope.languages){
                        for(var k in $scope.languages){
                            if($scope.stringToFilter.trim() && $scope.data[i][$scope.languages[l]] && $scope.data[i][$scope.languages[l]].toLowerCase().indexOf($scope.stringToFilter.toLowerCase())>=0){
                                $scope.data[i].filtered = true
                            }
                        }
                    }
                }
            }

            var loaded = 0
            $scope.load = function(){
                $scope.languages.forEach(function (lang) {
                    FIREBASE.get('i18n', lang, function(response){
                        delete response.Id
                        $scope.jsons[lang] = response
                        traverse(response, process, '', lang);
                        loaded++
                        if(loaded==$scope.languages.length){
                            for(var k in $scope.dataMap){
                                var o = $scope.dataMap[k]
                                
                                $scope.data.push(o)
                            }
                            orderData()
                        }
                    })
                })
            }
            $scope.load()

            var orderData = function(){
                $scope.data.sort(function(a,b){ return a.name > b.name ? 1 : -1})
            }

            var orderObj = function(obj){
                return Object.keys(obj)
                    .sort()
                    .reduce((accumulator, key) => {
                        accumulator[key] = obj[key];

                        return accumulator;
                    }, {});
            }

            function createObjectFromPath(path, value) {
                const props = path.split('.');
                const obj = {};
                let currentObj = obj;
                for (let i = 0; i < props.length - 1; i++) {
                  const prop = props[i];
                  currentObj[prop] = {};
                  currentObj = currentObj[prop];
                }
                currentObj[props[props.length - 1]] = value;
                return obj;
              }

            $scope.labelChanged = function(label, lang){
                label.showSaving = false
                label.showError = false
                label.showSuccess = false
                label.showSave = true
                if(!label.changes) label.changes = {}
                label.changes[lang] = true
            }

            let getVersion = function(lang){
                let v = $scope.jsons[lang]._ ? $scope.jsons[lang]._.version : '0.0'
                return { major: parseInt(v.split('.')[0]), minor: parseInt(v.split('.')[1]) }
            }

            $scope.save = function(label){
                let countSave = $scope.languages.length
                $timeout(function(){
                    label.showSaving = true
                    label.showSave = false
                }, 10)
                for(var l in $scope.languages){
                    if(!label.changes || !label.changes[$scope.languages[l]]) { 
                        countSave--; 
                    } else {
                        let obj = createObjectFromPath(label.path + '.' + label.name, label[$scope.languages[l]])
                        obj._ = {
                            version: getVersion($scope.languages[l]).major + '.' + (getVersion($scope.languages[l]).minor+1),
                            date: new Date().getTime()
                        }
                        FIREBASE.write(['i18n', $scope.languages[l]], obj, function(response){
                            countSave--
                            if(countSave==0){
                                for(var l in $scope.languages){ 
                                    D.save('github', {id: 'CommitLabelsChanges', lang: $scope.languages[l]})
                                }
                                $timeout(function(){
                                    label.showSuccess = true
                                    label.showSaving = false
                                    $scope.load()
                                }, 10)
                            }
                        }, function(error){
                            $timeout(function(){
                                label.showError = true
                                label.showSaving = false
                                $scope.load()
                            }, 10)
                        })
                    }
                }
            }

            function sortJSON(object) {
                if (object instanceof Array) {
                    for (var i = 0; i < object.length; i++) {
                        object[i] = sortJSON(object[i]);
                    }
                    return object;
                } else if (typeof object != "object") return object;
            
                var keys = Object.keys(object);
                keys = keys.sort();
                var newObject = {};
                for (var i = 0; i < keys.length; i++) {
                    newObject[keys[i]] = sortJSON(object[keys[i]])
                }
                return newObject;
            }

            $scope.export = function(lang){
                traverse($scope.jsons['it_IT'], update, '', lang) //per riempire quelli non esistenti
                traverse($scope.jsons[lang], update, '', lang)
                for(var p in $scope.paths){
                    var path = $scope.paths[p].split('.')
                    var o = $scope.jsons[lang]
                    for(var i=0; i<path.length-1; i++){
                        o = o[path[i]]
                    }
                    o[path[path.length-1]] = orderObj(o[path[path.length-1]])
                }
                $scope.jsons[lang] = sortJSON($scope.jsons[lang])
                download(JSON.stringify($scope.jsons[lang], (k,v) => v===undefined ? '' : v, 4), lang + '.json', 'application/json')
            }

            $scope.exportMissing = function(){
                if(!$scope.showFilter || $scope.filter!='missing') { $scope.filterMissing() }
                var output = '\ufeffNome etichetta' + $rootScope.user.csvSep
                for(var l in $scope.languages){
                    output += $scope.languages[l] + $rootScope.user.csvSep
                }
                output += '\n'
                for(var d in $scope.data){
                    var label = $scope.data[d]
                    if(label.filtered){
                        output += label.path + '.' + label.name + $rootScope.user.csvSep
                        for(var l in $scope.languages){
                            output += '"' + (label[$scope.languages[l]] || '').replace(/"/g,'""') + '"' + $rootScope.user.csvSep
                        }
                        output += '\n'
                    }
                }
                download(output, 'MissingTranslations.csv', 'text/tab-separated-values')
            }
            $scope.exportDup = function(){
                if(!$scope.showFilter || $scope.filter!='dup') { $scope.filterDup() }
                var output = '\ufeffNome etichetta' + $rootScope.user.csvSep
                for(var l in $scope.languages){
                    output += $scope.languages[l] + $rootScope.user.csvSep
                }
                output += '\n'
                for(var d in $scope.data){
                    var label = $scope.data[d]
                    if(label.filtered){
                        output += label.path + '.' + label.name + $rootScope.user.csvSep
                        for(var l in $scope.languages){
                            output += '"' + (label[$scope.languages[l]] || '').replace(/"/g,'""') + '"' + $rootScope.user.csvSep
                        }
                        output += '\n'
                    }
                }
                download(output, 'DupTranslations.csv', 'text/tab-separated-values')
            }
            $scope.exportString = function(){
                if(!$scope.showFilter || $scope.filter!='string') { $scope.filterString() }
                var output = '\ufeffNome etichetta' + $rootScope.user.csvSep
                for(var l in $scope.languages){
                    output += $scope.languages[l] + $rootScope.user.csvSep
                }
                output += '\n'
                for(var d in $scope.data){
                    var label = $scope.data[d]
                    if(label.filtered){
                        output += label.path + '.' + label.name + $rootScope.user.csvSep
                        for(var l in $scope.languages){
                            output += '"' + (label[$scope.languages[l]] || '').replace(/"/g,'""') + '"' + $rootScope.user.csvSep
                        }
                        output += '\n'
                    }
                }
                download(output, 'FilteredTranslations.csv', 'text/tab-separated-values')
            }

            $scope.exportAll = function(){
                if(!$scope.showFilter || $scope.filter!='all') { $scope.filterAll() }
                var output = '\ufeffNome etichetta' + $rootScope.user.csvSep
                for(var l in $scope.languages){
                    output += $scope.languages[l] + $rootScope.user.csvSep
                }
                output += '\n'
                for(var d in $scope.data){
                    var label = $scope.data[d]
                    
                    output += label.path + '.' + label.name + $rootScope.user.csvSep
                    for(var l in $scope.languages){
                        output += '"' + (label[$scope.languages[l]] || '').replace(/"/g,'""') + '"'  + $rootScope.user.csvSep
                    }
                    output += '\n'
                    
                }
                download(output, 'AllTranslations.csv', 'text/tab-separated-values')
            }

            function download(data, filename, type) {
                var file = new Blob([data], {type: type});
                if (window.navigator.msSaveOrOpenBlob) // IE10+
                    window.navigator.msSaveOrOpenBlob(file, filename);
                else { // Others
                    var a = document.createElement("a"),
                            url = URL.createObjectURL(file);
                    a.href = url;
                    a.download = filename;
                    document.body.appendChild(a);
                    a.click();
                    setTimeout(function() {
                        document.body.removeChild(a);
                        window.URL.revokeObjectURL(url);  
                    }, 0); 
                }
            }

            $scope.add = function(path){
                if($scope.newLabel[path].name){
                    var o = { path: path, name: $scope.newLabel[path].name }
                    let exists = $scope.data.filter((d) => d.path==path && d.name==$scope.newLabel[path].name).length>0
                    if(exists) { alert('Label already exists'); return;}
                    for(var l in $scope.languages){
                        o[$scope.languages[l]] = $scope.newLabel[path][$scope.languages[l]]
                    }
                    o.showSave = true
                    $scope.data.push(o)
                    //orderData()
                    for(var l in $scope.languages){
                        update($scope.newLabel[path].name, $scope.newLabel[path][$scope.languages[l]], path, $scope.languages[l])
                    }
                    $scope.newLabel[path] = {}
                }
            }

            $scope.openimportform = function(l){
                $scope.importLang = l
                ngDialog.open({
                    template: '/app/views/entities/labels-import.html',
                    className: 'ngdialog-theme-large ngdialog-theme-xxlarge',
                    scope: $scope
                });

                $scope.labelsImportForm = {
                    title: 'Importa etichette per ' + $scope.importLang,
                    model: {
                        lang: $scope.importLang,
                        labels: ''//JSON.stringify(sortJSON($scope.jsons[$scope.importLang]),null,2)
                    },
                    fields: [
                        {
                            available: true,
                            name: 'labels',
                            type: 'textarea',
                            rows: 30,
                            required: true,
                            label: 'JSON',

                        },
                        {
                            available: true,
                            type: 'submit'
                        }
                    ],
                    submit: function(){
                        ngDialog.openConfirm({
                            template: '/app/views/entities/confirm.html',
                            className: 'ngdialog-theme-default',
                            scope: $scope
                          }).then(function (value) {
                            D.save('i18n', {id:'UploadLabels', lang: $scope.importLang, labels: JSON.parse($scope.labelsImportForm.model.labels)}).then(function(response){
                                if(response.data.error){
                                    $scope.labelsImportForm.status = 'error';
                                    $scope.labelsImportForm.errorLabel = response.data.error;
                                } else {
                                    ngDialog.close();
                                    $scope.load()
                                }
                            })
                          })
                    }

                }
            }

            
        }
    ]);